module.exports = __webpack_public_path__ + "img/background_4.591879ad.jpg";